import {
  SCOOTER_LOADING,
  SCOOTER_ERROR,
  SCOOTER_LIST,
  SCOOTER_FILTERS,

  SCOOTER_ACTION_LOCK,
  SCOOTER_ACTION_UNLOCK,
  // SCOOTER_ACTION_VOICE,
  // SCOOTER_ACTION_OPEN_COVER,
} from "actions/scooter/scooter/constants";

const initialState = {
  loading: false,
  errors: [],

  filters: [],
  list: {
    content: []
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SCOOTER_LOADING:
      return {
        ...state,
        loading: action.payload.content
      };
    case SCOOTER_ERROR:
      return {
        ...state,
        loading: false,
        errors: action.payload.content
      };
    case SCOOTER_FILTERS:
      return {
        ...state,
        errors: [],
        filters: action.payload.content,
      };
    case SCOOTER_LIST:
      return {
        ...state,
        loading: false,
        errors: [],
        list: action.payload,
      };
    case SCOOTER_ACTION_LOCK:
      return {
        ...state,
        loading: false,
        errors: [],
        list: {
          ...state.list,
          content: state.list.content.reduce((acc, current) => {
            if (current.id === action.payload) {
              current.locked = true;
            }
            return acc.concat(current);
          }, [])
        }
      };
    case SCOOTER_ACTION_UNLOCK:
      return {
        ...state,
        loading: false,
        errors: [],
        list: {
          ...state.list,
          content: state.list.content.reduce((acc, current) => {
            if (current.id === action.payload) {
              current.locked = false;
            }
            return acc.concat(current);
          }, [])
        }
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/scooter/scooter/scooterReducer.js